import { InputAdornment, type TextFieldProps } from '@mui/material';

import { CommonNumberInput } from '@/components/Common/CommonNumberInput';

type Props = Omit<TextFieldProps, 'value' | 'onChange' | 'type'> & {
  value: number | null | undefined;
  onChange?: (value: number | null) => void;
  /** Percent fields get a trailing % instead of a leading $. */
  unit?: 'dollar' | 'percent';
};

/**
 * Dollar (or percent) input used across the loan application so amounts read
 * the same everywhere — "450,000", never "450000" next to "10,000".
 */
export function MoneyField({
  value,
  onChange,
  unit = 'dollar',
  InputProps,
  ...rest
}: Props) {
  return (
    <CommonNumberInput
      fullWidth
      {...rest}
      value={value ?? ''}
      onChange={(e) => {
        const raw = e.target.value;
        onChange?.(raw === '' ? null : Number(raw));
      }}
      InputProps={{
        ...(unit === 'percent'
          ? {
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }
          : {
              startAdornment: (
                <InputAdornment position="start">$</InputAdornment>
              ),
            }),
        ...InputProps,
      }}
    />
  );
}
